import util from '../lib/util';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
class Answer extends Base implements EntityType {
    answerId: uuid;
    questionId: uuid;
    value?: string | null;
    encryptedValue?: string | null;
    position?: number | null;
    constructor(doc: typeof Answer | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            answerId: genUUID(),
            questionId: null,
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "answer";
        // @ts-ignore
        this.answerId = doc._answerId || doc.answerId || doc.answerid || genUUID();
        // @ts-ignore
        this.questionId = doc._questionId || doc.questionId || doc.questionid || null;
        // @ts-ignore
        this.value = doc._value || doc.value || null;
        // @ts-ignore
        this.encryptedValue = doc._encryptedValue || doc.encryptedValue || doc.encryptedvalue || null;
        // @ts-ignore
        this.position = util.coalesce(util.parseInt(doc._position), util.parseInt(doc.position), util.parseInt(doc.position), null);
    }
    get id(): uuid { return this.answerId; }
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique id for this answer"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","mergeStrategy":"immutable","comment":"Associated firm"}]; }
    toLowerCase() { return this.answerId; }
    static override getNonRefArrayFields(): string[] { return []; }
    static override getDefaultEntries(): Answer[] {
        return [];
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'answer',
    table: 'ANSWER',
    comment: `A user's response to a custom Question, linked to an entity (lead, matter, contact, or other) via entityId/entityType. The value is stored as a string and interpreted according to the question's answerType (Text, Date, Money, Contact(s), etc.); sensitive answers are stored in an encrypted column instead.`,
    fields: {
        answerId: {
            type: 'uuid',
            required: true,
            pk: true,
            default: '__UUID__',
            comment: 'Unique id for this answer'
        },
        questionId: {
            type: 'uuid',
            entityType: 'question',
            required: true,
            comment: 'The base question'
        },
        value: {
            type: 'string',
            comment: `The answer, stored as a string; how it's interpreted depends on the related question's answer type`
        },
        encryptedValue: {
            type: 'string',
            encrypted: true,
            comment: 'If the question requires encryption, we store the answer in an encrypted field'
        },

        // Transients
        position: {
            type: 'int',
            transient: true,
            comment: 'Temporary position based on order of Question'
        }
    },
    maps: [
        {
            name: 'relatedTo',
            keysFn: t => t.entityId,
            presentFn: (t, k) => t.entityId === k
        },
        {name: 'questionId', keysFn: t => t.questionId, presentFn: (t, k) => t.questionId === k},
    ],
});
    }
}
export default Answer;
